import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const NotFound = lazy(() => import('../../container/pages/404'));
const EditLoyaltyPointsForm = lazy(() => import('../../container/loyaltyPoints/EditLoyaltyPointsForm'));
const LoyaltyPointsList = lazy(() => import('../../container/loyaltyPoints'));

function LoyaltyPointsSettingsRoute() {
  return (
    <Routes>
      <Route path="/" element={<LoyaltyPointsList />} />
      <Route path="/:id/edit" element={<EditLoyaltyPointsForm />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default LoyaltyPointsSettingsRoute;
